module.exports = __webpack_public_path__ + "static/media/company.9fe7c0fe.svg";